import {
  FeatureModelUnion,
  SectionChainItem,
  SectionModel,
} from '../../fetch-data/graphql';

export const isContentFeature = (feature: FeatureModelUnion): boolean => {
  return (
    feature?.__typename === 'QsgContentfeatureModel' ||
    feature?.__typename === 'QsgContentFeatureModel'
  );
};

export const isDisclaimerFeature = (feature: FeatureModelUnion): boolean => {
  return (
    feature?.__typename === 'QsgDisclaimerfeatureModel' ||
    feature?.__typename === 'QsgDisclaimerFeatureModel'
  );
};

export const isIconListFeature = (feature: FeatureModelUnion): boolean => {
  return (
    feature?.__typename === 'QsgIconlistfeatureModel' ||
    feature?.__typename === 'QsgIconlistFeatureModel'
  );
};

export const isMediaFeature = (feature: FeatureModelUnion): boolean => {
  return (
    feature?.__typename === 'QsgMediafeatureModel' ||
    feature?.__typename === 'QsgMediaFeatureModel'
  );
};

// Helper to normalize search term
export function normalizeSearchTerm(searchTerm: string): string {
  return searchTerm.replace(/\s+/g, ' ').trim().toLowerCase();
}

// Helper to create section chain item
export function createSectionChainItem(
  section: SectionModel
): SectionChainItem {
  return {
    sectionId: section.sectionId || '',
    sectionName: section.sectionName || '',
    sectionTitle: {
      html: section.sectionTitle?.html || null,
      plaintext: section.sectionTitle?.plaintext || null,
    },
  };
}
